import { trackEvent } from 'user-analytics';
import {
  EXCHANGE_LOGIN_ATTEMPT,
  EXCHANGE_RESCHEDULE_ATTEMPT,
  EXCHANGE_MODIFY_TRIP_ATTEMPT,
  EXCHANGE_CHANGE_TO_INVOICE_ATTEMPT,
  EXCHANGE_RUC_CORRECTION_ATTEMPT,
} from 'constants/TrackEvents';

/**
 * Helper function to track exchange login attempts
 * @param {boolean} isSuccess - Whether the login was successful
 * @param {string|null} errorMessage - Error message if failed
 */
export const trackExchangeLogin = (isSuccess, errorMessage = null) => {
  trackEvent(EXCHANGE_LOGIN_ATTEMPT, {
    'Is Success': isSuccess,
    'Error Message': errorMessage,
  });
};

/**
 * Helper function to track exchange reschedule attempts
 * @param {boolean} isSuccess - Whether the reschedule was successful
 * @param {string|null} errorMessage - Error message if failed
 */
export const trackRescheduleAttempt = (isSuccess, errorMessage = null) => {
  trackEvent(EXCHANGE_RESCHEDULE_ATTEMPT, {
    'Is Success': isSuccess,
    'Error Message': errorMessage,
  });
};

/**
 * Helper function to track exchange modify trip attempts
 * @param {boolean} isSuccess - Whether the modification was successful
 * @param {string|null} errorMessage - Error message if failed
 */
export const trackModifyTripAttempt = (isSuccess, errorMessage = null) => {
  trackEvent(EXCHANGE_MODIFY_TRIP_ATTEMPT, {
    'Is Success': isSuccess,
    'Error Message': errorMessage,
  });
};

/**
 * Helper function to track billing attempts (invoice or RUC correction)
 * @param {string} modalType - Type of billing operation ('invoice' or 'correction')
 * @param {boolean} isSuccess - Whether the operation was successful
 * @param {string|null} errorMessage - Error message if failed
 */
export const trackBillingAttempt = (modalType, isSuccess, errorMessage = null) => {
  const eventName =
    modalType === 'invoice' ? EXCHANGE_CHANGE_TO_INVOICE_ATTEMPT : EXCHANGE_RUC_CORRECTION_ATTEMPT;
  trackEvent(eventName, {
    'Is Success': isSuccess,
    'Error Message': errorMessage,
  });
};
